import { render, staticRenderFns } from "./EvaluationCriteriaModal.vue?vue&type=template&id=10c600fb&scoped=true&"
import script from "./EvaluationCriteriaModal.vue?vue&type=script&lang=js&"
export * from "./EvaluationCriteriaModal.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationCriteriaModal.vue?vue&type=style&index=0&id=10c600fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c600fb",
  null
  
)

export default component.exports